import React from "react";
import { string, bool, arrayOf, shape, func } from "prop-types";
import cx from "classnames";

const propTypes = {
  type: string,
  required: bool,
  error: bool,
  name: string.isRequired,
  label: string.isRequired,
  errorMsg: string,
  checked: bool,
  value: string,
  defaultValue: string,
  inputdescription: string,
  fullWidth: bool,
  autocomplete: string,
  options: arrayOf(
    shape({
      value: string,
      text: string,
      selected: bool,
    }),
  ),
  matchName: string,
  readonly: bool,
  jsClass: string,
  placeholder: string,
  onChange: func,
};

const selectInput = props => {
  const {
    type,
    required,
    error,
    name,
    label,
    errorMsg,
    value,
    defaultValue,
    fullWidth,
    autocomplete,
    options = [],
    matchName,
    readonly,
    jsClass,
    placeholder,
    onChange,
  } = props;

  const id = `GUID-${Math.floor(Math.random() * 1000)}`;
  const selectClass = jsClass || "";

  return (
    <label
      className={cx("select-form-item sc-form-item sc-form-item--select", {
        "js-form-required": required,
        "sc-form-item--optional": !required,
        "sc-form-item--full-width": fullWidth,
        "has-error": error,
      })}
    >
      <span className="select-form-item__text sc-form-item__label">
        {label}
      </span>
      <div className="select-form-item__input-wrapper">
        <select
          data-type={type}
          name={name}
          id={id}
          aria-required={required}
          autoComplete={autocomplete}
          data-match={matchName}
          readOnly={readonly}
          data-value={value ?? defaultValue}
          className={`select-form-item__field sc-form-item__field ${selectClass}`}
          onChange={onChange}
          {...(value !== undefined ? { value } : { defaultValue })}
          defaultValue={""}
        >
          <option value="" disabled>
            {placeholder || "Please select an option"}
          </option>
          {options.map((option, ind) => (
            <option key={`${ind}-${option.value}`} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
      </div>
      <span role="alert" className="sc-form-item__error-msg">
        {errorMsg}
      </span>
    </label>
  );
};

selectInput.propTypes = propTypes;
export default selectInput;
